/**
 * Adzuki.CustomConfirm v2
 * https://confluence.cruiseplannersnet.com/display/AP/Utlizing+Custom+Confirms
 */

(function CustomConfirm($, Adzuki)
{
	"use strict";

	var defaults = {
		body            : 'Are you sure you wish to continue?',
		title           : 'Decision Time',
		icon            : Adzuki.FaIcon.getIconStyle('info_circle'),
		confirm_btn_text: 'Yes',
		cancel_btn_text : 'No',
		close_icon      : false,

		// uncommon jconfirm option override ability
		animation         : 'opacity',
		animateFromElement: false,
		backgroundDismiss : false,
		theme             : 'bootstrap',
	};

	var confirm = function confirm(opts)
	{
		var _opts,
		    buttons;

		if (typeof opts !== 'object') {
			throw new Error('Expecting opts object, got ' + typeof opts);
		}

		_opts = $.extend({}, defaults, opts);

		if (opts.confirm && opts.url) {
			throw new Error('Cannot use confirm and url options together');
		}

		buttons = {
			confirm: {
				text  : _opts.confirm_btn_text,
				action: function _confirmAction() {
					var $includeCheckbox = this.$body.find('#include-checkbox');

					if (typeof _opts.confirm === 'function') {
						if (_opts.checkBox && _opts.checkBox.length > 0) {
							_opts.confirm($includeCheckbox.prop('checked'));
						} else {
							_opts.confirm();
						}
					}
					else if (_opts.url) {
						if (_opts.url_new_tab) {
							window.open(_opts.url, '_blank');
						} else {
							window.location.href = _opts.url;
						}
					}
				}
			},
		};

		// an optional third choice between confirm and cancel, for a confirm whose
		// cancel means "not now" and needs a separate "no" (TS-430)
		if (_opts.other_btn_text) {
			buttons.other = {
				text  : _opts.other_btn_text,
				action: function _otherAction() {
					if (typeof _opts.other === 'function') {
						_opts.other();
					}
				}
			};
		}

		buttons.cancel = {
			text  : _opts.cancel_btn_text,
			action: function _cancelAction() {
				if (typeof _opts.cancel === 'function') {
					_opts.cancel();
				}
			}
		};

		return $.confirm({
			// uncommon jconfirm option overrides
			animation         : _opts.animation || defaults.animation,
			animateFromElement: _opts.animateFromElement || defaults.animateFromElement,
			backgroundDismiss : _opts.backgroundDismiss || defaults.backgroundDismiss,
			theme             : _opts.theme || defaults.theme,

			// on close, jConfirm scrolls back to what opened it; when that is gone (a
			// deleted row, a closed menu) it scrolls to the top of the page instead
			scrollToPreviousElement: _opts.scrollToPreviousElement !== false,

			// common overrides
			title    : _opts.title || defaults.title,
			content  : _opts.content || _opts.body || defaults.body,
			icon     : _opts.icon,
			closeIcon: _opts.close_icon,
			buttons  : buttons,
			onClose  : function _onClose() {
				if (typeof _opts.on_close === 'function') {
					_opts.on_close();
				}
			},
			onOpenBefore: function _applyAdzukiStyle() {
				var jCofirmContent = $('.jconfirm-content');

				this.$body.addClass('adzuki-status confirm');

				if (_opts.checkBox && _opts.checkBox.length > 0) {	
					$("<br><label style='float:left;'><input id='include-checkbox' type='checkbox'/>&nbsp;" + _opts.checkBox + "</label>").appendTo(jCofirmContent);
				}

			}
		});
	};

	// the delete confirm, in both apps (MEDIA-333, Media Tags' pattern): a warning
	// icon, a title naming what goes ("Delete “X”?"), and verb buttons. Callers
	// pass title, content and confirm_btn_text ("Delete trip summary"); the
	// cancel button reads "Keep it" unless they name it.
	confirm.destructive = function destructiveConfirm(opts)
	{
		return confirm($.extend({
			icon                   : Adzuki.FaIcon.getIconStyle('warning'),
			cancel_btn_text        : 'Keep it',
			// what opened a delete confirm usually goes with the deleted item, and
			// jConfirm would then scroll the page to the top
			scrollToPreviousElement: false,
		}, opts));
	};

	// a name for a confirm's title or content, which render as HTML
	confirm.escape = function escapeForConfirm(text)
	{
		return $('<div>').text(String(text || '')).html();
	};

	// handle .confirm-link links
	// binding found in Adzuki/_global.js
	confirm.link = function linkConfirm($link)
	{
		confirm({
			title           : $link.data('confirm-title'),
			body            : $link.data('confirm-message'),
			// data-confirm-destructive: the delete confirm's warning icon (MEDIA-333)
			icon            : $link.data('confirm-icon') || ($link.is('[data-confirm-destructive]') ? Adzuki.FaIcon.getIconStyle('warning') : undefined),
			confirm_btn_text: $link.data('ok-text'),
			cancel_btn_text : $link.data('cancel-text'),
			confirm         : function _linkConfirmed() {
				// ADZ-8420: data-method="post" submits instead of navigating, so the
				// confirmed action cannot also be reached by anything that merely follows
				// the url. Adzuki.postTo() is defined in Adzuki/_global.js and shared with
				// the .post-link handler there.
				if ($link.data('method') === 'post') {
					Adzuki.postTo($link.attr('href'));

					return;
				}

				if ($link.data('new-tab') === undefined) {
					window.location.href = $link.attr('href');
				} else {
					window.open($link.attr('href'), '_blank');
				}
			}
		});
	};

	Adzuki.CustomConfirm = confirm;
}(jQuery, window.Adzuki || {}));
